import { observable, action, makeObservable } from "mobx";

const initialState = {
  isUserLogin: false,
};

class ProfileStore {
  isUserLogin = initialState.isUserLogin;
  email = "";

  isUserLoggedIn = () => {
    return fetch("api/user/islogin/", {
      method: "get",
      headers: { "Content-Type": "application/json" },
    });
  };

  constructor() {
    makeObservable(this, {
      isUserLogin: observable,
      email: observable,
      isUserLoggedIn: action,
      deleteCard: action,
      getCloudImages: action
    });
  }

  deleteCard() {
    return fetch("api/stripe/deleteCard/", {
      method: "delete",
      headers: { "Content-Type": "application/json" },
    });
  }
  getCloudImages() {
    return fetch("/api/backend/cloud_images/?type=en", {
      method: "get",
      headers: { "Content-Type": "application/json" },
    });
  }
}

export default ProfileStore;



// WEBPACK FOOTER //
// ./src/stores/ProfileStore.js